import { render, staticRenderFns } from "./ModalLogs.vue?vue&type=template&id=457bb529&scoped=true&lang=pug&"
import script from "./ModalLogs.vue?vue&type=script&lang=js&"
export * from "./ModalLogs.vue?vue&type=script&lang=js&"
import style0 from "./ModalLogs.vue?vue&type=style&index=0&id=457bb529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457bb529",
  null
  
)

export default component.exports